import React, { useState } from "react";
import { Form, FormGroup, Label, Input, Button } from "reactstrap";
import UserServices from "../services/UserServices";

const ForgetPassword = () => {
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [alert, setAlert] = useState("");

    const handleSubmit = (e) => {
        e.preventDefault();
        // code pour soumettre le formulaire et envoyer un e-mail de récupération de mot de passe
        let user = ''
        if (email !== "") {
            user = {
                email: email
            }

            UserServices.ForgetPassword(user).then(data => {
                console.log(data);
                setAlert("");
                if (data['success'] === true) {
                    setMessage(data['message']);
                } else if (data['success'] === false) {
                    setMessage("");
                    setEmail("");
                    setAlert(data['message']);
                }
            });
        } else {

        }
    };

    return (
        <div className="container">
            <div className="row">

                {message && <div className="alert alert-success mt-1">{message}</div>}
                {alert && <div className="alert alert-danger mt-1">{alert}</div>}
                <br />
                <br />
                <br />
                <div className="col-md-4"></div>
                <div className="col-md-4 mt-5">
                    <h3 className="text-center mb-3">Mot de passe oublié</h3>
                    <Form onSubmit={handleSubmit}>
                        <FormGroup>
                            <Input
                                type="email"
                                name="email"
                                id="email"
                                placeholder="Entrez votre adresse e-mail"
                                value={email}
                                required={true}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </FormGroup>
                        <Button color="primary" type="submit">
                            Envoyer
                        </Button>
                    </Form>
                </div>
                <div className="col-md-4"></div>
            </div>
        </div>
    );
};

export default ForgetPassword;
